import axios from "axios";
import * as config from "../api/config";
import { whiteListURL } from "../Utils/constants";

export const GET = async (path, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.get(endpoint.toString(), {
      headers: headers,
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const POST = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.post(endpoint.toString(), payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const PUT = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.put(endpoint.toString(), payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const DELETE = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.delete(
      endpoint.toString(),
      {
        headers: headers,
      },
      payload
    );
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const POSTFORMDATA = async (path, formData, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "multipart/form-data",
       Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "multipart/form-data",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

   try {
    const response = await axios.post(endpoint.toString(), formData, {
      headers,
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const GETSERVICE = async (path, params = {}, options = {}) =>{
   const token = localStorage.getItem("token");
   var headers;
   if (token) {
     headers = {
       "Content-Type": "application/json",
       Authorization: `Bearer ${token}`,
     };
   } else {
     headers = {
       "Content-Type": "application/json",
     };
   }
   const baseURL = new URL(config.API_URL);
   const endpointPath = path;
   const endpoint = new URL(endpointPath, baseURL);
 
   if (!whiteListURL.includes(baseURL.origin)) {
     throw new Error("Blocked: origin not in whitelist");
   }

   try {
    const response = await axios.get(endpoint.toString(), {
      headers,
      params,
      responseType: options.responseType || "json",
    });

    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
}

export const POSTSERVICE = async (path, data = {}, token) => {
  var headers;
  if (token) {
   headers = {
     "Content-Type": "application/json",
     Authorization: `Bearer ${token}`,
   };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.post(endpoint.toString(), data, { headers });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
}

export const DELETESERVICE = async (path, data = {}, token) =>{
  var headers;
   if (token) {
   headers = {
     "Content-Type": "application/json",
     Authorization: `Bearer ${token}`,
   };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.delete(endpoint.toString(), {
      headers,
      data,
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
}

export const GETBINARYDATA =  async (path, token, responseType) =>{
   var headers;
   if (token) {
   headers = {
     "Content-Type": "application/binary",
     Authorization: `Bearer ${token}`,
   };
  } else {
    headers = {
      "Content-Type": "application/binary",
    };
  }
  const baseURL = new URL(config.API_URL);
  const endpointPath = path;
  const endpoint = new URL(endpointPath, baseURL);

  if (!whiteListURL.includes(baseURL.origin)) {
    throw new Error("Blocked: origin not in whitelist");
  }

  try {
    const response = await axios.get(endpoint.toString(), {
      headers,
      responseType,
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
}